import DataList from "./src/index.vue";
import type { App } from "vue";
DataList.install = function (Vue: App): void {
  console.info("DataLoad----install----");
  Vue.component(DataList.name, DataList);
};

export default DataList;
